export default {
  'zh-tw': {
    loginV2_formSubtitle: '請使用您的帳號密碼登入，或先從下方查看可用的第三方登入方式。',
    loginV2_providerAction: '使用 {provider} 登入',
    loginV2_localDivider: '帳號密碼登入',
    loginV2_registerCta: 'Email/手機註冊帳號',
    loginV2_registerSubtitle: '建立您的帳號，開始使用 HiTeach 服務。',
    loginV2_switchToLoginPrefix: '已經有帳號了，',
    loginV2_switchToLoginAction: '立即登入',
    loginV2_switchToRegisterPrefix: '沒有帳號嗎？',
    loginV2_switchToRegisterAction: '馬上註冊',
    loginV2_heroTitle: 'HiTeach 助您開啟智慧教學新旅程',
    loginV2_heroSubtitle: '現在註冊醍摩豆帳號，解鎖多重免費授權，即刻開始您的教學新旅程。'
  },
  'zh-cn': {
    loginV2_formSubtitle: '请使用您的帐号密码登录，或先查看下方可用的第三方登录方式。',
    loginV2_providerAction: '使用 {provider} 登录',
    loginV2_localDivider: '帐号密码登录',
    loginV2_registerCta: 'Email/手机注册账号',
    loginV2_registerSubtitle: '建立您的醍摩豆账号，开始使用 HiTeach 服务。',
    loginV2_switchToLoginPrefix: '已经有账号了，',
    loginV2_switchToLoginAction: '立即登入',
    loginV2_switchToRegisterPrefix: '没有账号吗？',
    loginV2_switchToRegisterAction: '马上注册',
    loginV2_heroTitle: 'HiTeach 助您开启智慧教学新旅程',
    loginV2_heroSubtitle: '现在注册醍摩豆账号，解锁多重免费授权，即刻开始您的教学新旅程。'
  },
  'en-us': {
    loginV2_formSubtitle: 'Use your account and password to sign in, or review the available third-party options below.',
    loginV2_providerAction: 'Continue with {provider}',
    loginV2_localDivider: 'Account login',
    loginV2_registerCta: 'Register via Email/Mobile',
    loginV2_registerSubtitle: 'Create your TEAM Model account and get started with HiTeach.',
    loginV2_switchToLoginPrefix: 'Already have an account?',
    loginV2_switchToLoginAction: 'Log in now',
    loginV2_switchToRegisterPrefix: 'Don\'t have an account?',
    loginV2_switchToRegisterAction: 'Register now',
    loginV2_heroTitle: 'Transform Lessons with HiTeach',
    loginV2_heroSubtitle: 'Register now to unlock multiple free licenses.'
  },
  'ja-jp': {
    loginV2_formSubtitle: 'アカウントとパスワードでログインするか、下の利用可能な外部ログイン方法をご確認ください。',
    loginV2_providerAction: '{provider}でログイン',
    loginV2_localDivider: 'アカウントログイン',
    loginV2_registerCta: 'メールアドレス/携帯電話でアカウント登録',
    loginV2_registerSubtitle: 'TEAM Modelアカウントを作成し、すぐにHiTeachサービスを開始しましょう。',
    loginV2_switchToLoginPrefix: 'すでにアカウントをお持ちですか？',
    loginV2_switchToLoginAction: '今すぐログイン',
    loginV2_switchToRegisterPrefix: 'アカウントをお持ちでないですか？',
    loginV2_switchToRegisterAction: '今すぐ登録',
    loginV2_heroTitle: 'GIGAスクール構想 × HiTeach：スマート教室の新時代をリード',
    loginV2_heroSubtitle: '今すぐ登録して、複数の無料ライセンスをアンロックしましょう。'
  },
  'ko-kr': {
    loginV2_formSubtitle: 'Use your account and password to sign in, or review the available third-party options below.',
    loginV2_providerAction: 'Continue with {provider}',
    loginV2_localDivider: 'Account login',
    loginV2_registerCta: 'Register via Email/Mobile',
    loginV2_registerSubtitle: 'Create your TEAM Model account and get started with HiTeach.',
    loginV2_switchToLoginPrefix: 'Already have an account?',
    loginV2_switchToLoginAction: 'Log in now',
    loginV2_switchToRegisterPrefix: 'Don\'t have an account?',
    loginV2_switchToRegisterAction: 'Register now',
    loginV2_heroTitle: 'Transform Lessons with HiTeach',
    loginV2_heroSubtitle: 'Register now to unlock multiple free licenses.'
  }
}
